export default __webpack_public_path__ + "static/media/ceo1.04048caa.svg";